import cloneDeep from 'lodash.clonedeepwith'


class TextOptionMapping {
  constructor(text, parent) {
    this.text = text
    this.data = cloneDeep(text.data)
    this.parent = parent
  }
}

export default TextOptionMapping